import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuth, clearAuth, getUser, getToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getUser());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (!token) return;
    // ALWAYS verify the stored token on boot — a cached `di_user` is not proof
    // the token is still valid (JWT secret may have rotated, admin may have logged out
    // elsewhere, or the token may be expired). The 401 interceptor in api.js will
    // handle redirect on failure; here we just refresh the user object.
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { clearAuth(); setUser(null); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAuth(data.token, data.user);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { clearAuth(); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, login, logout, loading, setLoading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
